import {useState, useEffect} from 'react';
//import {useNavigate} from 'react-router-dom';
//import {useLocation} from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import AnalyticsContainerKPI from '../components/rts/Analytics/AnalyticsContainerKPI';
import AnalyticsContainerReports from '../components/rts/Analytics/AnalyticsContainerReports';

import { useSessionContext } from '../contexts/SessionContext';

export default function AnalyticsPage( props ){
    //console.debug("RTS Break AnalyticsPage");

    const {curFilter, setCurFilter} = useSessionContext();

    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const [formDirty, setFormDirty] = useState(0);
    const [tabIndex, setTabIndex] = useState(0);
    const [newTabIndex, setNewTabIndex] = useState(0);

    useEffect(() => {
        props.setIsModalFx(false);
        if(curFilter != null && curFilter.key === 'AnalyticsPage'){
            setTabIndex(curFilter.tabIndex);
        }
        else{
            setTabIndex(0);
        }

    }, [props, curFilter]); 


    const handleChange = (e, curIndex) => {
        setNewTabIndex(curIndex);
        if(formDirty===1){
            setShowConfirmModal(true);
        }
        else{
            switchTabs(curIndex);
        }
    };


    function switchTabs(curIndex){
        window.scrollTo(0,0);
        setShowConfirmModal(false);
        setFormDirty(0);
        setTabIndex(curIndex);
        setCurFilter({key:'AnalyticsPage', tabIndex:curIndex});
    }      


    return(
        <>
        <Dialog fullWidth={true} open={showConfirmModal}>
            <DialogTitle>Leave Tab?</DialogTitle>
            <DialogContent>
                <Typography>Changes will be lost.</Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {switchTabs(newTabIndex);}}>Yes</Button>
                <Button variant="contained" onClick={e => {setShowConfirmModal(false);}}>No</Button>
            </DialogActions>
        </Dialog> 
        <Container component="main" sx={{mb:5}}>
            <CssBaseline />
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb:1 }}>
                <Tabs value={tabIndex} onChange={handleChange}>
                    <Tab label="KPI(s)" value={0}  />
                    <Tab label="Reports" value={1} />
                </Tabs>
            </Box>
            {
            tabIndex === 1
            ?
                <AnalyticsContainerReports />
            :
                <AnalyticsContainerKPI />
            }
        </Container>
        </>   
    );
}
